import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import * as _ from 'lodash';

export const AuthFeatureKey = 'auth';

export interface State {
  loaded: boolean;
  loading: boolean;
  validating: boolean;
  validated: boolean;
  checked: boolean;
  auth: {
    user_uuid: string;
    token: string;
    partner_uuid: string;
  } | undefined;
  error?: Error | HttpErrorResponse;
}

export const initialState: State = {
  loaded: false,
  loading: false,
  validating: false,
  validated: false,
  auth: undefined,
  checked: false
};

export const reducer = createReducer(
  initialState,


  on(AuthActions.loginSuccess, AuthActions.validateAuthSuccess, (state: State, action) => ({
    ...state,
    loaded: true,
    loading: false,
    validated: true,
    validating: false,
    auth: {
      partner_uuid: _.get(action, 'data.partner_uuid', _.get(state, 'auth.partner_uuid', '')),
      user_uuid: action.data.user_uuid as string,
      token: action.data.token as string
    },
    error: undefined,
    checked: true
  })),

  on(AuthActions.loginFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
    checked: true
  })),

  on(AuthActions.validateAuth, (state, action) => ({
    ...state,
    validating: true
  })),

  on(AuthActions.validateAuthFailure, (state, action) => ({
    ...state,
    loading: false,
    validating: false,
    validated: false,
    error: action.error,
    checked: true
  })),

  on(AuthActions.noSessionFound, (state, action) => ({
    ...state,
    checked: true
  }))
);
